import React, { useEffect } from "react";
import styles from "./styles.module.scss";
import {
  fetchApplication
} from "../../store/actions/student.action";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import loaderIcon from "../../assets/loader.svg";
import ConsentForm from "../ConsentForm/ConsentForm";
import verifiedIcon from "../../assets/verified-now-icon.svg"
import { useMsal } from "@azure/msal-react";
const ConsentBox = () => {

  const { accounts } = useMsal();
  const cosnsetFromSave = localStorage.getItem("consent-form")
  const dispatch = useDispatch();
  const fetchApplicationReducer = useSelector(
    (state) => state.studentReducers.fetchApplication
  );

  const submitConsentReducer = useSelector(
    (state) => state.studentReducers.submitConsent
  );
  useEffect(() => {
    const payloadData = {
      official_email: accounts[0].username
    }
    dispatch(fetchApplication.request(payloadData))
  }, []);


  return (
    <div className={styles.applicationBox}>
      <div className={styles.wrapper}>
        {(fetchApplicationReducer?.loading || submitConsentReducer.loading) ? (
          <div className={styles.loader}>
            <img src={loaderIcon} alt="loader icon" />
            <span className={styles.loadingText}>Loading...</span>
          </div>
        ) : (
          <>
            {(fetchApplicationReducer?.data?.application_status >= 6) ? (
              <div className={styles.applicationStatus}>
                {((fetchApplicationReducer?.data?.consent_version !== null && fetchApplicationReducer?.data?.consent_version !== "") || submitConsentReducer.success === true) ?
                  <div className={styles.verified}>
                    <img src={verifiedIcon} alt="verified icon" />
                    {cosnsetFromSave === "submit" ? <span className={styles.verifiedText}>
                      Thank you for completing the GIS consent form, <br />our Admissions team will review this in due course and be in touch to confirm that your enrolment is complete.
                    </span> : <span className={styles.verifiedText}>
                      You have already completed your consent form with GIS for this academic year. <br/>You have been sent a copy of your consent responses to your email address for your records.
                    </span>}

                  </div> : <ConsentForm />}
              </div>
            ) : <></>}
          </>
        )}

        <div className={styles.footer}>
          <h4 className={styles.footerText}>
            Need some help? Contact us at admissions@gis.sport
          </h4>
        </div>
      </div>

    </div>
  );
};

ConsentBox.propTypes = {};

export default ConsentBox;
